import React, { useState } from 'react';
import HeaderSingleProduct from './Header';
import ClientDetail from './ClientDetail';
import LivraisonDetail from './LivraisonDetail';
import ProduitDetail from './ProduitDetail';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { ContainerTwoThirds } from 'components/layouts/ContainerTwoThirds';
import { BackButton } from 'components/molecules/Buttons/BackButton';
import { IconLabel } from 'components/atoms/Texts/IconLabel';
import { formatDate } from 'helpers/date/formatDate';
import { IS_PROF } from 'helpers/user/authorization';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { useToCommandePages } from 'hooks/useToCommandePages';
import useStyle from './commandeSingle.style';
import { updateCommande } from 'REST/commande/updateCommande';
import { CommandeStateUpdate } from 'types/commande/formatUpdateCommande';
import { initialState } from 'components/organisms/forms/UpdateCommande';
import { Enum_Commande_Status } from 'graphql/generated/graphql';
import { CommandeDef } from '../../types/commande/commande.def';
import { Modal } from '../../components/organisms/Modals/Modal';
import { formatUpdateCommande } from '../../helpers/commande/formatUpdateCommande';
import { WarningHeaderBlock } from 'components/molecules/Blocks/WarningHeaderBlock';
import { refreshPage } from 'helpers/page/refreshPage';

interface CommandeSingle {
  commande: CommandeDef;
  onUpdatePayment?: () => Promise<void>;
}

const CommandeSingle = ({ commande, onUpdatePayment }: CommandeSingle) => {
  const [loading, setLoading] = useState(false);
  const client = commande.client;
  const commandelines = commande.commandelines;
  const classes = useStyle();
  const [cmdState] = useState<CommandeStateUpdate>(initialState(commande));
  const [, toCommandeUpdatePage] = useToCommandePages();

  const onClick = async () => {
    if (onUpdatePayment) {
      setLoading(true);
      await onUpdatePayment();
      refreshPage();
    }
  };

  const cancelOrder = async () => {
    await updateCommande(
      formatUpdateCommande({
        ...cmdState,
        commande: { ...cmdState.commande, status: Enum_Commande_Status.Annule }
      })
    );
  };

  return (
    <ContainerFullWidth>
      {client.affilie && (
        <div className={classes.back}>
          <BackButton text="Revenir aux commandes" />
        </div>
      )}
      {commande.orderNeedToBeReminded && (
        <div className={classes.commandeNeedReminder}>
          <FeatureContainer padding="small">
            <div className={classes.commandeNeedReminderContent}>
              <div>
                <WarningHeaderBlock variant="CommandeSingle" />
              </div>
              <ButtonWithText
                content="Envoyer mail de relance"
                onClick={onClick}
                loading={loading}
              />
            </div>
          </FeatureContainer>
        </div>
      )}
      {!client.affilie && !commande?.livraison?.status && (
        <ContainerTwoThirds
          col1={
            <>
              <div className={classes.back}>
                <BackButton text="Revenir aux commandes" />
              </div>
              <div className={classes.head}>
                <IconLabel
                  withoutMargin={true}
                  icon="Profile"
                  label={client.prenom + ' ' + client.nom}
                />
                <IconLabel
                  withoutMargin={true}
                  icon="Calendar"
                  label={formatDate(new Date(commande.createdAt))}
                />
              </div>
            </>
          }
          col2={
            IS_PROF && (
              <div className={classes.buttonsHead}>
                <ButtonWithText
                  onClick={() => toCommandeUpdatePage(commande.id)}
                  content="Modifier la commande"
                />
                <Modal
                  modalHead={'Souhaitez-vous annuler cette commande ?'}
                  triggerButton={
                    <ButtonWithText
                      variant="danger"
                      onClick={null}
                      disabled={commande.status === Enum_Commande_Status.Annule}
                      content="Annuler la commande"
                    />
                  }
                  actionButton={
                    <ButtonWithText
                      variant="danger"
                      onClick={cancelOrder}
                      disabled={commande.status === Enum_Commande_Status.Annule}
                      content="Annuler la commande"
                    />
                  }
                >
                  <p>
                    Si vous souhaitez annuler cette commande, cliquez sur le
                    bouton "Annuler la commande".
                  </p>
                </Modal>
              </div>
            )
          }
        />
      )}

      <ContainerTwoThirds
        col1={
          <div className={classes.root}>
            <HeaderText
              text="Informations de facturation"
              emoji={emojis['Crayon']}
            />
            <FeatureContainer>
              <ClientDetail client={client} />
            </FeatureContainer>
            <HeaderText
              text="Informations de livraison"
              emoji={emojis['PostBox']}
            />
            <FeatureContainer>
              <LivraisonDetail client={client} />
            </FeatureContainer>
          </div>
        }
        col2={
          <div className={classes.root}>
            <HeaderText
              text="Informations commande"
              emoji={emojis['Package']}
            />
            <FeatureContainer>
              <HeaderSingleProduct commande={commande} />
            </FeatureContainer>
            <HeaderText
              text="Liste des produits commandés"
              emoji={emojis['ShoppingBags']}
            />
            <FeatureContainer>
              {commandelines && commandelines.length > 0 ? (
                <ProduitDetail commandelines={commandelines} />
              ) : (
                <p>Commande vide.</p>
              )}
            </FeatureContainer>
          </div>
        }
      />
      {!IS_PROF && !client.affilie && (
        <p className={classes.redText}>
          * Pour modifier cette commande, veuillez contacter le professeur
        </p>
      )}
    </ContainerFullWidth>
  );
};

export default CommandeSingle;
